import React, { useEffect, useState } from 'react';
import { Box, Typography, List, ListItemButton, Divider, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PATHS } from '../../routes/paths';
import ConfirmModal from '../common/ConfirmModal';

const menuItems = [
  { label: '마닐라 소식', path: PATHS.newsList },
  { label: 'E-TRAVEL/픽드랍', path: PATHS.etravelPickdrop },
  { label: '유흥/골프/식당', path: PATHS.shops },
  { label: '링크모음', path: PATHS.links },
];

const MainMenuDrawer = ({ open, onClose, onNavigate }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [logoutOpen, setLogoutOpen] = useState(false);

  useEffect(() => {
    if (!open) return;
    try {
      const raw = window.localStorage.getItem('currentUser');
      if (raw) {
        setCurrentUser(JSON.parse(raw));
      } else {
        setCurrentUser(null);
      }
    } catch {
      setCurrentUser(null);
    }
  }, [open]);

  const handleClick = (path) => {
    if (onNavigate) {
      onNavigate(path);
    }
  };

  const handleLogoutConfirm = () => {
    setLogoutOpen(false);
    if (onNavigate) {
      onNavigate(PATHS.root);
    }
  };

  const isLoggedIn = Boolean(currentUser);
  const isAdmin = currentUser?.role === 'ADMIN';

  const displayMenuItems = isAdmin
    ? [
        ...menuItems,
        { label: '관리자 페이지', path: PATHS.adminUsers },
      ]
    : menuItems;

  if (!open) return null;

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          width: '92%',
          bgcolor: 'white',
          zIndex: 10,
          boxShadow: 2,
        }}
      >
        <Box sx={{ px: 2, pt: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, mt: '2px' }}>
            <IconButton
              onClick={onClose}
              sx={{ width: 34, height: 34}}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        {!isLoggedIn && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0, mb: 3, mt: '30px' }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, fontSize: 24, cursor: 'pointer' }}
              onClick={() => handleClick(PATHS.login)}
            >
              로그인
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 700, fontSize: 24 }}>/</Typography>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, fontSize: 24, cursor: 'pointer' }}
              onClick={() => handleClick(PATHS.register)}
            >
              회원가입
            </Typography>
          </Box>
        )}

        {isLoggedIn && (
          <Box sx={{ mb: 3, mt: '30px' }}>
            <Typography
              variant="h6"
              sx={{ fontWeight: 700, fontSize: 24, cursor: 'pointer' }}
              onClick={() => handleClick(PATHS.myPage)}
            >
              마이페이지
            </Typography>
          </Box>
        )}
          <Divider />
          <List disablePadding>
            {displayMenuItems.map((item) => (
              <React.Fragment key={item.label}>
                <ListItemButton
                  onClick={() => handleClick(item.path)}
                  sx={{
                    fontSize: 16,
                    minHeight: 56, 
                    px: 2,
                  }}
                >
                  {item.label}
                </ListItemButton>
                <Divider />
              </React.Fragment>
            ))}
          </List>
        </Box>
      </Box>

      <ConfirmModal
        open={logoutOpen}
        message="로그아웃이 되었습니다."
        onConfirm={handleLogoutConfirm}
      />
    </>
  );
};

export default MainMenuDrawer;


